import React, { ReactElement } from 'react'
import CaptionFont from '../../../../Theme/Fonts/Caption'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'

type RowFontProps = {
    children: string | number
    bold?: boolean
    small?: boolean
}

const RowFont = ({ bold, children, small }: RowFontProps): ReactElement => {
    const Font = small ? CaptionFont : SmallBodyFont
    return (
        <Font color="onyx" bold={bold} textAlign="center" numberOfLines={1}>
            {`${children}`}
        </Font>
    )
}

export default RowFont
